import { IResponseData, ResultDatas } from "@/models/common";
import { IFileListItem } from "@/models/file";
import { AxiosResponse } from "axios";
import api from "../api/api";
import { ApiFileManager } from "./";
import getApiResponse from "@/api/apiResponse";

export enum DataType {
  DICOM = "DICOM",
  IMAGE = "IMAGE",
  DOCUMENT = "DOCUMENT",
  VIDEO = "VIDEO",
  PASSPORT = "PASSPORT",
  IDCARD = "IDCARD",
}

export enum FileType {
  PDF = "PDF",
  JPG = "JPG",
  ZIP = "ZIP",
}

const getFileList = async (key: string) => {
  const params = {
    reftab: "request",
    refkey: key,
  };
  const res: AxiosResponse<IResponseData<
    IFileListItem
  >> = await api.get(ApiFileManager.GET_FILE_LIST, { params });
  const {
    data: { ResultData },
  } = res;
  if (!Array.isArray(ResultData)) return [];
  else return ResultData;
};

const getFileBlob = async (key: string) => {
  const params = {
    fileKey: key,
  };
  const res: AxiosResponse<any> = await api.get(ApiFileManager.GET_FILE, {
    params,
    responseType: "blob",
  });

  const {
    data: { ResultCode, Exception },
  } = res;

  if (ResultCode && ResultCode !== 0) {
    throw Exception;
  }

  return res.data as Blob;
};

export const FileService = {
  async getFileList(key: string) {
    // const params = {
    //   reftab:"request",
    //   refkey:key
    // }
    // return await api.get(ApiFileManager.GET_FILE_LIST, {params});
    const result = await getFileList(key);
    return result;
  },

  async getFileBlob(key: string) {
    const result = await getFileBlob(key);
    return result;
  },

  async getStudyKeys(fileKey: string) {
    const params = {
      fileKey,
    };
    const resp: AxiosResponse<IResponseData<
      Array<number>
    >> = await api.get(ApiFileManager.GET_STUDY_KEYS, { params });
    return getApiResponse<Array<number>>(resp);
  },

  getFilePath(filePath: string) {
    return `/${process.env.VUE_APP_SUB_URL}/Uploads/${filePath}`;
  },

  getFileDownLoadPath(filePath: string) {
    return `/Uploads/${filePath}`;
  },

  getPdfPath(filePath: string) {
    // console.log(api.defaults.baseURL + "Uploads/" + filePath)
    return `${process.env.BASE_URL}lib/pdfjs-2.6.347-dist/web/viewer.html?file=/${process.env.VUE_APP_SUB_URL}/Uploads/${filePath}`;
  },

  async downloadFile(filePath: string, title: string) {
    const res = await api.get(filePath, { responseType: "blob" });
    const fileURL = URL.createObjectURL(res.data);
    const fileLink = document.createElement("a");

    fileLink.setAttribute("download", title);
    fileLink.href = fileURL;
    fileLink.click();
  },

  async deleteFile(fileKey: number) {
    const params = { fileKey };
    const resp: AxiosResponse<IResponseData<string>> = await api.get(ApiFileManager.DELETE_FILE, {
      params,
    });
    return getApiResponse<string>(resp) === ResultDatas.SUCCESS;
  },
};
export default FileService;
